import navigation from './navigation.js';
import menus from './menus.js';
import agentManagement from './agentManagement.js';
import gpuReplacement from './gpuReplacement.js';

import customerLookup from './customerLookup.js';

export default {
    ...navigation,
    ...agentManagement,
    ...menus,
    ...customerLookup,
    ...gpuReplacement,
};
